/**
 * 标签输入组件
 * 用于正面词、负面词等标签列表输入
 */

import React, { useState, useEffect } from 'react';
import { Input, Tag, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

interface TagInputProps {
  value?: string[];
  onChange?: (value: string[]) => void;
  placeholder?: string;
  disabled?: boolean;
}

const TagInput: React.FC<TagInputProps> = ({
  value = [],
  onChange,
  placeholder = '输入后按回车添加',
  disabled = false,
}) => {
  const [inputValue, setInputValue] = useState('');

  const handleInputConfirm = () => {
    if (inputValue && inputValue.trim() && !value.includes(inputValue.trim())) {
      onChange?.([...value, inputValue.trim()]);
      setInputValue('');
    }
  };

  const handleTagClose = (tag: string) => {
    onChange?.(value.filter((v) => v !== tag));
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleInputConfirm();
    }
  };

  return (
    <div>
      <Space wrap style={{ marginBottom: 8 }}>
        {value.map((tag) => (
          <Tag
            key={tag}
            closable={!disabled}
            onClose={() => handleTagClose(tag)}
            style={{ marginBottom: 4 }}
          >
            {tag}
          </Tag>
        ))}
      </Space>
      {!disabled && (
        <Input
          value={inputValue}
          onChange={handleInputChange}
          onPressEnter={handleInputConfirm}
          onBlur={handleInputConfirm}
          onKeyDown={handleInputKeyDown}
          placeholder={placeholder}
          prefix={<PlusOutlined />}
        />
      )}
    </div>
  );
};

export default TagInput;
